import { render, staticRenderFns } from "./WoundSiteObservations.vue?vue&type=template&id=5bf84ea5&"
import script from "./WoundSiteObservations.vue?vue&type=script&lang=js&"
export * from "./WoundSiteObservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports